export default {
      id: "eye-slash-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.e22fd14f.svg#eye-slash",
      toString: function () {
        return this.url;
      }
    }